const svgModules = import.meta.glob<{ default: any }>("./**/*.svg", { eager: true });

// Create a map of component names to their imports
export const icons: Record<string, any> = {};

Object.entries(svgModules).forEach(([path, module]) => {
  // Convert path to PascalCase name
  // e.g., './heroicons/chart-pie.svg' -> 'ChartPieIcon'
  const name =
    path
      .split("/")
      .pop()!
      .replace(".svg", "")
      .split("-")
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join("") + "Icon";

  icons[name] = module.default;
});
